import styled from 'styled-components';
import imageCountry from '~/assets/Brazil.png';

export const Container = styled.div`
  width: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 78vh;

  .content {
    display: flex;
    max-width: 640px;
    width: 100%;
    justify-content: space-between;
    padding-top: 30px;

    .image-country {
      span {
        background-image: url(${imageCountry});
        background-repeat: no-repeat;
        background-position: center;
        width: 300px;
        height: 300px;
        text-indent: -5000em;
        display: inline-block;
        background-size: contain;
      }
    }

    .welcome {
      flex-direction: column;
      display: flex;
      justify-content: center;
      padding-right: 50px;

      h2 {
        color: #707070;
        font-size: 2.2em;
        margin: 0;
      }
      h1 {
        margin: 0;
        color: #fff;
        font-size: 2.7em;
      }
    }

    @media (max-width: 1260px) {
      display: none;
    }
  }
`;

export const Header = styled.div`
  height: 70px;
  width: 100%;
  background: #201f1f;
`;

export const Nav = styled.div`
  width: 270px;
  background: #262525;
`;

export const Content = styled.div`
  width: 100%;
  background: #292828;
`;
